import { Component } from 'react';
import styles from './StateView.module.css';

export class StateView extends Component {
    renderImage() {
        const { image } = this.props;

        if (!image) return null;

        return (
            <div className={styles.image} data-testid="state-view-image">
                {image}
            </div>
        );
    }

    renderHeader() {
        const headerMessage = this.props.headerMessage;
        return <div className={styles.header}>{headerMessage}</div>;
    }

    renderDescription() {
        const descriptionMessage = this.props.descriptionMessage;
        return (
            <div
                data-testid="state-view-description"
                className={styles.description}
            >
                {descriptionMessage}
            </div>
        );
    }

    render() {
        const image = this.renderImage();
        const header = this.renderHeader();
        const description = this.renderDescription();
        return (
            <div
                className={styles.StateView}
                data-testid={this.props['data-testid'] || 'state-view'}
            >
                <div className={styles.inner}>
                    {image}
                    {header}
                    {description}
                </div>
            </div>
        );
    }
}
